import * as React from 'react';
import { ArrowLeft } from 'react-feather';
import { useRouter } from '../../hooks';
import styled from 'styled-components';
import { device } from '../../utils/device';
import Flex from './Flex';

const Title = styled.h2`
  display: flex;
  font-weight: 600;
  margin-top: 3px;
  @media ${device.mobileS} {
    font-size: 1em;
  }
  @media ${device.mobileM} {
    font-size: 1.2em;
  }
  @media ${device.mobileL} {
    font-size: 1.2em;
  }
  @media ${device.tablet} {
    font-size: 1.5em;
  }
`;

const FormTitle = styled.p`
  margin-top: 3px;
  @media ${device.mobileS} {
    margin-top: 4px;
  }
  @media ${device.mobileM} {
    margin-top: 2px;
  }
  @media ${device.mobileL} {
    margin-top: 1px;
  }
  @media ${device.mobileM} {
    margin-top: 2px;
  }
  @media ${device.tablet} {
    margin-top: -1px;
  }
`;

const FormHeader: React.FC<{ title: string }> = ({ title }) => {
  const { history } = useRouter();

  return (
    <>
      <Flex direction="row" size="" ml={3}>
        <Title onClick={() => history.goBack()}>
          <ArrowLeft />
          <FormTitle>{title}</FormTitle>
        </Title>
      </Flex>
    </>
  );
};

export default FormHeader;
